<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcheckbox from "@/router/views/FormComponet/formcheckbox.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIcDegerTablo from "@/models/StrIcDegerTablo";
export default {
  mixins: [Api, Sabit, StrIcDegerTablo],
  props: ["Id", "AddEdit", "Seviye", "UstId","DegerlendirmeTur"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput, 
    formcheckbox,
    formtextarea,
    formcombobox
  },
  watch: {
    Id() {
      this.FormData = this.Id; 
      this.FormData.Seviye = this.Seviye;
    },
    UstId() {
      if(this.UstId){
        this.FormData.UstId = this.UstId;
      }
    }


  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        if (this.AddEdit == "Add") {
          if(this.Seviye != 0){
            this.FormData.Degerlendirmetur = this.DegerlendirmeTur;
          }
          this.Post("StrIcDegerTablo", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIcDegerTablo");
              this.FormData.Sirano = "";
              this.FormData.Tabloadi = "";
              this.FormData.UstId = null;

            }
          }); 
        } else {
          if(this.Seviye != 0){
            this.FormData.Degerlendirmetur = this.DegerlendirmeTur;
          }
          this.Update("StrIcDegerTablo", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIcDegerTablo");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrIcDegerTablo"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrSorgular.AddEdit.FormTitleEdit')
          : $t('StrSorgular.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">   
        <forminput
          :FormDataType="FormDataType.Tabloadi"
          :Value="FormData.Tabloadi"
          :v="$v.FormData.Tabloadi"
          @input="FormData.Tabloadi = $event"
        />  
        <div class="row">
          <div class="col-md-6">
            <forminput
            :FormDataType="FormDataType.Sirano"
            :Value="FormData.Sirano"
            :v="$v.FormData.Sirano"
            @input="FormData.Sirano = $event"
          />
        </div>
        <div class="col-md-3">
            <formcheckbox
            :FormDataType="FormDataType.Aktif"
            :Value="FormData.Aktif"
            :v="$v.FormData.Aktif"
            @input="FormData.Aktif = $event"
          />
        </div>

                <div class="col-md-3">
            <formcheckbox v-if="FormData.Seviye == 2"
            :FormDataType="FormDataType.Olgunlukvarmi"
            :Value="FormData.Olgunlukvarmi"
            :v="$v.FormData.Olgunlukvarmi"
            @input="FormData.Olgunlukvarmi = $event"
          />
        </div>
        <div class="col-md-6">
        <formcombobox v-if="FormData.Seviye == 0"

          :FormDataType="FormDataType.Degerlendirmetur"
          :Value="FormData.Degerlendirmetur"
          :v="$v.FormData.Degerlendirmetur"
          @input="FormData.Degerlendirmetur = $event"
        />


      </div>

        </div>
        <formtextarea v-if="FormData.Seviye == 2"
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />
        <forminput v-if="FormData.Seviye == 2"
          :FormDataType="FormDataType.Olgunluk1"
          :Value="FormData.Olgunluk1"
          :v="$v.FormData.Olgunluk1"
          @input="FormData.Olgunluk1 = $event"
        />
        <forminput v-if="FormData.Seviye == 2"
          :FormDataType="FormDataType.Olgunluk2"
          :Value="FormData.Olgunluk2"
          :v="$v.FormData.Olgunluk2"
          @input="FormData.Olgunluk2 = $event"
        />
        <forminput v-if="FormData.Seviye == 2"
          :FormDataType="FormDataType.Olgunluk3"
          :Value="FormData.Olgunluk3"
          :v="$v.FormData.Olgunluk3"
          @input="FormData.Olgunluk3 = $event"
        />
        <forminput v-if="FormData.Seviye == 2"
          :FormDataType="FormDataType.Olgunluk4"
          :Value="FormData.Olgunluk4"
          :v="$v.FormData.Olgunluk4"
          @input="FormData.Olgunluk4 = $event"
        />
        <forminput v-if="FormData.Seviye == 2"
          :FormDataType="FormDataType.Olgunluk5"
          :Value="FormData.Olgunluk5"
          :v="$v.FormData.Olgunluk5"
          @input="FormData.Olgunluk5 = $event"
        />
        <button class="btn btn-primary" type="submit">
          {{ $t("StrSorgular.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
